<template>
    <div class="education-info">
          <div class="education-info__edit text-right">
              <h3 class=" font-size-16 primary-color font-family-Semibold cursor-pointer">Chỉnh sửa</h3>
          </div>
          <div class="education-info__school display-flex">
              <div class="avatar-user">
                  <img src="@/assets/images/user.png" alt="">
              </div>
              <div class="name">
                  <h3 class="font-size-16 primary-color font-sanpro-semibold cursor-pointer">Trường Tiểu học Nguyễn Tất Thành</h3>
                  <span class="font-size-14 font-family-Semibold secondary-color-txt">Hà Nội</span>
              </div>
          </div>
           <div class="education-info__school display-flex">
              <div class="avatar-user">
                  <img src="@/assets/images/user.png" alt="">
              </div>
              <div class="name">
                  <h3 class="font-size-16 primary-color font-sanpro-semibold cursor-pointer">Trường Tiểu học Nguyễn Tất Thành</h3>
                  <span class="font-size-14 font-family-Semibold secondary-color-txt">Hà Nội</span>
              </div>
          </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { STORE_KEY } from "../../_store/constants";
export default {

    name:"Education",
    data(){
        return{

        }
    },
      computed: {
    ...mapGetters({
      getBaseInfo: STORE_KEY + "/getBaseInfo"
    }),
  },
}
</script>

<style lang="scss" scoped>
  .education-info{
      &__edit{
        margin-bottom:20px;
      }
      &__school{
            padding: 15px 0 7px 0;
            border-bottom: 1px solid #d8d8d8;
            //  border-top: 1px solid #d8d8d8;
            .avatar-user{
                padding:0 15px;
                img{
                  height: 30px;
                }
            }
            .name{
                margin-bottom: 0;
                margin-top: 0;
            }
      }
  }
</style>